import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  forceRefresh () {
    if('caches' in window){
      caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach(name => {
              caches.delete(name);
          })
      });
    }
    window.location.reload();
    return true;
  }

}
